// extracted by mini-css-extract-plugin
export default {"container":"GoogleAuth_container__eOgfZ","button":"GoogleAuth_button__7hvCc"};